/**
 * Base: storage-only responsibilities (no network or DOM work).
 */
export class MediaFontStore {
  protected _map: Map<string, any>

  constructor() {
    this._map = new Map()
  }

  set(fontName: string, font: any): void {
    this._map.set(fontName, font)
  }

  get(fontName: string): any | null {
    return this._map.get(fontName) ?? null
  }

  has(fontName: string): boolean {
    return this._map.has(fontName)
  }

  delete(fontName: string): boolean {
    return this._map.delete(fontName)
  }

  clear(): void {
    this._map.clear()
  }
}
